/**
 * 公共语言配置
 */
/* eslint-disable global-require */
export default {
  // 网站名称
  websiteName: 'Think Academy MYS',
  // 导航配置
  navigationLinks: [
    {
      name: 'Home',
      url: '/',
    },
    {
      name: 'Courses',
      url: '',
      children: [
        {
          name: 'Kindergarten',
          url: '/courses/aggregational-detail/251',
          target: '',
        },
        {
          name: 'Year 1',
          url: '/courses/aggregational-detail/152',
          target: '',
        },
        {
          name: 'Year 2',
          url: '/courses/aggregational-detail/153',
          target: '',
        },
        {
          name: 'Year 3',
          url: '/courses/aggregational-detail/154',
          target: '',
        },
        {
          name: 'Year 4',
          url: '/courses/aggregational-detail/155',
          target: '',
        },
        {
          name: 'Year 5',
          url: '/courses/aggregational-detail/156',
          target: '',
        },
        {
          name: 'Year 6',
          url: '/courses/aggregational-detail/157',
          target: '',
        },
      ],
    },
    {
      name: 'Our teachers',
      url: '/teachers',
      target: '',
    },
    // {
    //   name: 'Free resources',
    //   url: '/resources',
    //   target: '',
    // },
    {
      name: 'Download App',
      url: '/download',
      target: '',
    },
    {
      name: 'Careers',
      url: '/careers/job-listings',
      className: '',
      target: '_blank',
      isLink: true,
    },
    {
      name: 'About us',
      url: '',
      target: '',
      children: [{
        name: 'About Think Academy',
        url: '/about-think-academy',
        target: '',
      }, {
        name: 'About TAL',
        url: 'https://en.100tal.com',
        target: '_blank',
      }],
    },
  ],
  // 用户下拉菜单链接配置
  userNavigationLinks: [
    {
      name: 'My Account',
      url: '/settings',
      target: '',
    },
    {
      name: 'My Courses',
      url: '/my-courses/list',
      target: '',
    },
    {
      name: 'My Orders',
      url: '/order/list',
      target: '',
    },
    // {
    //   name: 'My Subscription',
    //   url: '/subscription-manage',
    //   target: '',
    // },
    {
      name: 'Unpaid Courses',
      url: '/my-unpaid-courses/list',
      target: '',
      mark: true,
    },
    {
      name: 'My Family',
      url: '/my-account',
      target: '',
    }, {
      name: 'Sign Out',
      url: '',
      target: '',
      isLink: false,
    }],

  // 个人中心侧边导航
  sideNavigationLinks: [{
    list: [
      {
        name: 'My Courses',
        url: '/my-courses/list',
        keyword: 'my-courses',
        iconName: 'icon-course',
      },
      {
        name: 'Test Results',
        url: '/test/test-results',
        keyword: 'test-results',
        handle: 'toPlacementTest',
        iconName: 'icon-test',
      },
      {
        name: 'My Orders',
        url: '/order/list',
        keyword: 'order',
        iconName: 'icon-order',
      },
      // {
      //   name: 'Subscription Management',
      //   url: '/subscription-manage',
      //   keyword: 'subscription-manage',
      //   iconName: 'icon-subscription',
      // },
    ],
  }, {
    list: [
      {
        name: 'Unpaid Courses',
        url: '/my-unpaid-courses/list',
        keyword: 'my-unpaid-courses',
        iconName: 'icon-upaid-courses',
        mark: true,
      },
      {
        name: 'Class Reschedule/Transfer',
        url: '/my-class-transfer',
        keyword: 'my-class-transfer',
        iconName: 'icon-switch',
      },
      {
        name: 'My Coupons',
        url: '/my-coupons/list',
        keyword: 'my-coupons',
        iconName: 'icon-coupon',
      },
      {
        name: 'Wish List',
        url: '/my-wish/list',
        keyword: 'my-wish',
        iconName: 'icon-wish-list',
      },
    ],
  }],

  // 底部栏配置
  // 关于我们
  aboutUs: {
    title: 'About Us',
    links: [{
      name: 'About Think Academy',
      url: '/about-think-academy',
      target: '_self',
    }, {
      name: 'About TAL',
      url: 'https://en.100tal.com',
      target: '_blank',
    }, {
      name: 'Job Opportunities',
      url: '/careers/job-listings',
      target: '_self',
    }],
  },
  // 联系我们
  contactUs: {
    title: 'Contact Us',
    displayType: 'contact',
  },

  // 友情链接
  otherSchool: {
    title: 'Our Global Branches',
  },

  // 关注社交账号
  follows: {
    title: 'Follow Think Academy',
    links: [{
      icon: 'icon-facebook2',
      name: 'Facebook',
      link: 'https://www.facebook.com/Think-Academy-Malaysia-108521741865207',
      target: '_blank',
      linkType: 'link',
    }, {
      icon: 'icon-whatsapp',
      name: 'WhatsApp',
      link: 'https://wa.me/message/YW6VVHRXUAELJ1?src=qr',
      target: '_blank',
      linkType: 'link',
    }],
  },

  // 法务协议
  policyLinks: [{
    name: 'Terms of Use',
    url: '/terms-of-use',
    target: '',
  }, {
    name: 'Safeguarding Policy',
    url: '/safeguarding-policy',
    target: '',
  }, {
    name: 'Privacy Policy',
    url: '/privacy-policy',
    target: '',
  }, {
    name: 'Investor Relations',
    url: 'https://ir.100tal.com',
    target: '_blank',
  }],

  // 侧边栏配置
  rightTools: [{
    name: 'Facebook',
    icon: 'icon-facebook',
    link: 'https://www.facebook.com/Think-Academy-Malaysia-108521741865207',
    target: '_blank',
    type: 'link',
  }, {
    name: 'WhatsApp',
    icon: 'icon-whatsapp',
    link: 'https://wa.me/message/YW6VVHRXUAELJ1?src=qr',
    target: '_blank',
    type: 'link',
  }],

  // 关注社交账号
  follow: {
    whatsappQrcode: '',
    facebookUrl: 'https://www.facebook.com/Think-Academy-Malaysia-108521741865207',
    wechatQrcode: require('assets/images/common/qrcode-my.jpg'),
    youtubeUrl: '',
    instagramUrl: '',
    linkedinUrl: '',
    twitterUrl: '',
  },
  // 工作机会
  jobOpportunities: '',
  // 公司信息
  companyInfo:
  [
    {
      text: 'Pusat Tuisyen Bistari  Matematik Sdn. Bhd.',
      isLink: false,
    },
    {
      text: '202301038868（1532788-D）',
      isLink: false,
    },
    {
      text: '© 2024 The Think Academy International Education Limited',
      isLink: false,
    },
  ],
  footerOtherInfo: [],
  // 联系方式
  contactEmail: 'Malaysia@tal.com',
  contactPhone: '',

  // 联系信息列表化
  // 标题+内容
  contactList: [],

  termsOfRefundUrl: '/terms-of-use',

  // 在线客服
  elfsightId: '',

  // 日期格式化方式
  dateFormat: 'DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
  dayMonthFormat: 'DD/MM',

  // 货币格式
  isKeepTwoDecimal: '0',

  // 税费名称
  taxName: 'VAT',
  taxIncluded: 'inc VAT',
  taxExcluded: 'VAT excluded',

  // 分享相关
  share: {
    downPoster: 'Save poster',
    copyLink: 'Copy link',
    clear: 'Cancel',
    downPosterSu: 'Sucess',
    referralDes: 'Copy the referral, long press and paste when sharing.',
    copyReferral: 'Copy the referral',
    copySu: 'Success!\n Send it to your friends!',
    sownSu: 'Success!\n Send it to your friends!',
    access: 'Please allow to access your Photos in the Settings.',
    shareTit: 'I have found a great course! Join my Group Buy to enjoy the discount!',
    weChat: 'WeChat',
    moments: 'Moments',
  },
}
